"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogConfirm = exports.confirmDialogType = void 0;
const DialogBase_1 = require("./DialogBase");
exports.confirmDialogType = "CONFIRM";
class DialogConfirm extends DialogBase_1.DialogBase {
    constructor(data) {
        super(exports.confirmDialogType);
        this.type = exports.confirmDialogType;
        this.cancel = () => {
            this.isOpen = false;
            if (this.postCancel) {
                this.postCancel();
            }
        };
        this.confirm = () => {
            this.isOpen = false;
            if (this.postConfirm) {
                this.postConfirm();
            }
        };
        this.confirmButtonLabel = data.confirmButtonLabel;
        this.cancelButtonLabel = data.cancelButtonLabel;
        this.message = data.message;
        this.title = data.title;
        this.postCancel = data.onCancel;
        this.postConfirm = data.onConfirm;
    }
}
exports.DialogConfirm = DialogConfirm;
